<!-- 房型详情 -->
<template>
  <van-popup
    v-model="show"
    round
    position="bottom"
    closeable
    :style="{maxHeight :'80%' }"
    @closed="detailClosed"
    class="detail_wrap_pop"
  >
    <!-- <div class="detail_wrap"> -->
    <div
      v-show="!loading && info.length != 0"
      class="detail_info_wrap"
      v-html="info"
    >
    </div>
    <div
      v-show="info.length == 0 && !loading"
      class="empty_wrap"
    >
      <CusEmpty :info="$t('global.empty')" />
    </div>
    <div
      v-show="loading"
      class="loading_wrap"
    >
      <van-loading
        class="loading_spinner"
        type="spinner"
      />
    </div>
    <!-- </div> -->
  </van-popup>
</template>

<script>
import Vue from 'vue'
import { Popup, Loading } from 'vant'
Vue.use(Popup)
Vue.use(Loading)

import CusEmpty from '@c/CusEmpty'

import { GetRoomDetail } from '@a/js/api/booking.js'
export default {
  name: 'RoomDetail',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    roomid: {
      type: String,
      default: ''
    },
  },

  watch: {
    show(val) {
      if (val) {
        this.loading = true
        this.wnanaRoomDetail()
      }
    },
    info(val) {
      if (val) {
        this.setAttribute()
      }
    }
  },
  data() {
    return {
      params: {},
      loading: false,
      info: ''
    };
  },

  components: {
    CusEmpty
  },

  methods: {
    // 获取参数信息
    GetParamsData() {
      return new Promise((resolve) => {
        this.params = this.$route.params
        resolve()
      })
    },
    // 请求详情信息
    wnanaRoomDetail() {
      let data = {
        account_uid: this.params.accountid,
        project_uid: this.params.projectid,
        hotel_uid: this.params.hotelid,
        room_uid: this.roomid
      }
      GetRoomDetail(data, this.$root.language).then(res => {
        this.info = res.data.introduction
        // console.log(this.info)
        this.loading = false
      }).catch(() => {
        this.info = ''
        this.loading = false
      })
    },
    // 关闭详情
    detailClosed() {
      this.$emit('listenCloseDetail')
    },
    // 获取图片列表
    setAttribute() {
      this.$nextTick(() => {
        let imgs = document.getElementsByTagName('img')
        imgs.forEach(img => {
          if (!img.className) {
            let imgParent = img.parentNode
            imgParent.style.fontSize = 0
          }
        });
      })
    }
  },

  mounted() {
    this.GetParamsData()
  },
}
</script>
<style lang='less' >
.detail_loading_wrap {
  height: 400px;
  position: relative;
}
.empty_wrap {
  padding: 40px 0;
}
.loading_wrap {
  min-height: 400px;
  position: relative;
  .loading_spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
}
.detail_info_wrap {
  min-height: 400px;
  padding: 40px 15px;
  font-size: 14px;
}
</style>